import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";
import {getSessionValue} from "../../Common/Appcommon";

class Mapview extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"Map View"} formname={"maplocator"} customClass={"field-customization-container "} />
        );
    }
}

export default Mapview;
